var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBlog3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M225.78,141.09H99.14V54.45H225.78Zm-125.64-1H224.78V55.45H100.14Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109.05,60a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,109.05,60Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.34,60a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,119.34,60Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.63,60a2.52,2.52,0,1,1-2.52-2.52A2.52,2.52,0,0,1,129.63,60Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.64,
    y: 64.47,
    width: 125.64,
    height: 1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M682.37,294.22l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.06h-.44v-.45L655.39,283v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V283c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05L669,294Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.6,308.33l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.07c4.41,0,8.83.11,13.24.16h.28v.27c0,1.9-.08,3.79-.13,5.66Zm0,0-.14-5.65c-.05-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.83.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.18,0,4.36,0,6.55.05l6.57.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M697.14,308.33l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7.06h-.44v-.45l-.06-11.19v-.5h.5l13.24.07c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.14-5.65c0-1.86-.11-3.7-.13-5.54l.27.28c-4.41.05-8.82.16-13.24.16l-13.24.06.5-.5,0,11.19-.45-.44c2.19,0,4.36,0,6.55.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M324.79,161.07l-13.12.28-6.66.11c-2.23,0-4.47,0-6.7,0h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28v.27c0,1.9-.09,3.78-.14,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310,175.18l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.05h-.44v-.45L283,164v-.5h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28V164c0,1.9-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.83.16-13.24.16l-13.24.07.5-.5L284,175.18l-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.56,175.18l-13.12.28-6.66.11c-2.23,0-4.46,0-6.7.05h-.44v-.45L312.58,164v-.5h.5l13.24.06c4.42,0,8.83.11,13.24.16h.28V164c0,1.9-.09,3.78-.13,5.65Zm0,0-.14-5.66c0-1.86-.11-3.7-.13-5.53l.27.27c-4.41.05-8.82.16-13.24.16l-13.24.07.5-.5-.05,11.19-.45-.45c2.19,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.4,330.89l-13.12.27-6.67.12c-2.22,0-4.46,0-6.69.05h-.44v-.44l0-11.19v-.51h.5l13.24.06c4.41,0,8.83.11,13.24.16h.28v.27c0,1.89-.08,3.78-.13,5.65Zm0,0-.14-5.66c-.05-1.86-.11-3.7-.13-5.53l.27.27c-4.41,0-8.83.16-13.24.16l-13.24.07.5-.5-.06,11.19-.44-.45c2.18,0,4.36,0,6.54.05l6.58.12Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.86,161.06l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41.05-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.84,52.38l-13.12.28-6.67.11c-2.22,0-4.46,0-6.69.06h-.44v-.45l0-11.19v-.5h.5l13.24.06c4.41,0,8.83.12,13.24.17h.28v.27c0,1.9-.08,3.79-.13,5.65Zm0,0-.14-5.65c-.05-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.83.16-13.24.17l-13.24.06.5-.5-.05,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.57.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M695.61,66.49l-13.12.28-6.66.11c-2.23.05-4.47,0-6.7.05h-.44v-.45l-.06-11.19v-.5h.5l13.24.06c4.42,0,8.83.12,13.24.17h.28v.27c0,1.9-.09,3.79-.14,5.65Zm0,0-.14-5.65c0-1.87-.11-3.71-.13-5.54l.27.27c-4.41,0-8.82.16-13.24.17l-13.24.06.5-.5,0,11.19-.45-.45c2.18,0,4.36,0,6.55.06l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.34,52.39l-13.13.28-6.66.11c-2.22,0-4.46,0-6.69.06h-.45v-.45l0-11.19v-.5h.51l13.24.07c4.41,0,8.82.11,13.24.16h.27v.27c0,1.9-.09,3.79-.13,5.66Zm0,0-.15-5.65c0-1.87-.11-3.71-.13-5.54l.28.27c-4.42.06-8.83.16-13.24.17l-13.24.06.5-.5L53.3,52.39,52.86,52c2.18,0,4.35,0,6.54,0l6.58.11Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.84 286.32 85.16 304.55 61.77 215.1 113.5 201.57 131.44 196.88 135.9 213.92 154.84 286.32",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.83,
    y: 220.87,
    width: 58.67,
    height: 2.37,
    transform: "translate(255.23 411.29) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 73.35,
    y: 226.67,
    width: 58.67,
    height: 2.37,
    transform: "translate(259.68 422.31) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.87,
    y: 232.46,
    width: 58.67,
    height: 2.37,
    transform: "translate(264.13 433.34) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.38,
    y: 238.26,
    width: 58.67,
    height: 2.37,
    transform: "translate(268.57 444.36) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 77.9,
    y: 244.06,
    width: 58.67,
    height: 2.37,
    transform: "translate(273.02 455.38) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79.41,
    y: 249.86,
    width: 58.67,
    height: 2.37,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 277.47, 466.41)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 80.93,
    y: 255.65,
    width: 58.67,
    height: 2.37,
    transform: "translate(281.92 477.43) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82.45,
    y: 261.45,
    width: 58.67,
    height: 2.37,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 286.37, 488.45)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 83.96,
    y: 267.25,
    width: 58.67,
    height: 2.37,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 290.82, 499.47)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 85.48,
    y: 273.04,
    width: 58.67,
    height: 2.37,
    transform: "translate(295.27 510.5) rotate(165.35)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.99,
    y: 278.84,
    width: 58.67,
    height: 2.37,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 299.72, 521.52)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 88.51,
    y: 284.64,
    width: 58.67,
    height: 2.37,
    transform: "matrix(-0.97, 0.25, -0.25, -0.97, 304.17, 532.54)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "173.34 312.13 101.43 316.15 96.27 223.84 149.66 220.86 169.16 237.41 173.34 312.13",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "149.66 220.86 169.16 237.41 150.64 238.45 149.66 220.86",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.18,
    y: 237.82,
    width: 40.04,
    height: 2.37,
    transform: "translate(261.57 470.7) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.52,
    y: 243.8,
    width: 40.04,
    height: 2.37,
    transform: "translate(262.57 482.64) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.85,
    y: 249.79,
    width: 40.04,
    height: 2.37,
    transform: "translate(263.57 494.58) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.17,
    y: 255.25,
    width: 58.67,
    height: 2.37,
    transform: "translate(283.13 504.96) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.51,
    y: 261.23,
    width: 58.67,
    height: 2.37,
    transform: "translate(284.14 516.89) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 105.84,
    y: 267.21,
    width: 58.67,
    height: 2.37,
    transform: "translate(285.14 528.83) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.18,
    y: 273.2,
    width: 58.67,
    height: 2.37,
    transform: "translate(286.14 540.77) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.51,
    y: 279.18,
    width: 58.67,
    height: 2.37,
    transform: "translate(287.14 552.71) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 106.85,
    y: 285.16,
    width: 58.67,
    height: 2.37,
    transform: "translate(288.15 564.64) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.18,
    y: 291.15,
    width: 58.67,
    height: 2.37,
    transform: "translate(289.15 576.58) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.52,
    y: 297.13,
    width: 58.67,
    height: 2.37,
    transform: "translate(290.15 588.52) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 107.85,
    y: 303.11,
    width: 58.67,
    height: 2.37,
    transform: "translate(291.16 600.46) rotate(176.8)",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "579.43 124.61 648.41 175.38 682.32 129.21 613.34 78.44 579.43 124.61",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "584.4 123.84 647.66 170.4 677.34 129.97 614.08 83.42 584.4 123.84",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.57,100.24a8.54,8.54,0,1,0,11.94-1.82A8.55,8.55,0,0,0,610.57,100.24Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "604 138.36 647.57 170.44 647.52 124.87 604 138.36",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "586.91 125.81 622.88 152.28 619.05 119.81 586.91 125.81",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "554.42 102.77 640.06 103.92 640.77 46.64 555.12 45.49 554.42 102.77",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "558.02 99.25 636.56 100.31 637.17 50.16 558.63 49.11 558.02 99.25",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M565.56,64.84a8.55,8.55,0,1,0,8.66-8.44A8.55,8.55,0,0,0,565.56,64.84Z",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "582.4 99.66 636.5 100.39 609.95 63.36 582.4 99.66",
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "561.2 99.39 605.86 99.99 583.85 75.82 561.2 99.39",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M684.38,271.82C671.59,289.15,658.25,309.26,655,331c0,.33.49.44.56.11a130.3,130.3,0,0,1,5.66-17.39c8.41-2.32,16.67-4.22,21.08-12.57,4.51-8.58,3.94-19.77,3.08-29.12C685.32,271.51,684.64,271.49,684.38,271.82Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M661.35,313.53c5.74-12.89,13.12-25.84,22.5-36.45.06-.07.16,0,.1.1-6.14,7.56-10.8,15.78-15.36,24.15,4.24-4.3,8.88-8.15,12.89-12.71.08-.09.21,0,.13.13-4,4.78-8.33,10-13.52,13.51-1.4,2.57-2.8,5.15-4.22,7.72.34-.19.7-.36,1.06-.54.07,0,.12.06.06.09-.4.2-.79.41-1.2.59-.67,1.22-1.34,2.44-2,3.65C661.6,314,661.23,313.81,661.35,313.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M665.62,309a74.21,74.21,0,0,0,9.82-6.55c.09-.07.21,0,.12.12a52.34,52.34,0,0,1-9.8,6.68A.14.14,0,0,1,665.62,309Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.52,327.75a.24.24,0,0,0,.47,0c.06-7.15,0-14.34.11-21.53,1.83-3.7,5.77-5.75,8.5-8.71a38,38,0,0,0,5.11-7.11,51.16,51.16,0,0,0,5.92-19.74c.75-7.65-2.15-32.91-5.38-32-1.67.45-7.09,13-8.52,17.1a118.76,118.76,0,0,0-5.09,21C652,293.52,652.24,310.81,653.52,327.75Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M653.47,296.89l0,0c.39-9.06,2.43-18.2,4.34-27,2.06-9.46,4.46-18.37,9.33-26.81a.14.14,0,0,1,.24.14,99.52,99.52,0,0,0-7.49,20.58c.32-.51.72-1,1.06-1.48.13-.19.45,0,.31.19a12.86,12.86,0,0,1-1.52,2.15s0,0-.06,0c-1.68,6.76-2.88,13.67-3.91,20.57.08-.08.15-.18.23-.26s.14,0,.11.08c-.13.23-.28.45-.41.68-.52,3.5-1,7-1.49,10.46,6.24-5.33,11.56-11.61,14.57-19.35,0,0,.07,0,.05,0-2.94,8-7.58,15.16-14.72,20l-.39,2.8c0,.19-.34.14-.33,0,0-.83,0-1.66.07-2.48A.19.19,0,0,1,653.47,296.89Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M656.4,283.77c4.77-7.11,9.22-14,12.71-21.88,0-.09.19,0,.15.06-2.94,7.81-7,15.73-12.62,22C656.53,284.08,656.31,283.91,656.4,283.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662.74,260.13c2-3.49,4-6.89,5.91-10.45.05-.1.19,0,.15.08A54.24,54.24,0,0,1,663,260.31C662.91,260.49,662.62,260.33,662.74,260.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M662,261.65a0,0,0,0,1,0,.06A0,0,0,1,1,662,261.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M648.68,307.06a73.4,73.4,0,0,1-1.68,14.1c.08.51.15,1,.23,1.54A67.59,67.59,0,0,0,649.75,307a.5.5,0,0,0,0-.49h0a104.34,104.34,0,0,0-1.58-21.3C646,272,641.13,259.42,632,249.57a.65.65,0,0,0-1,.21c-3.7,9.41-2.41,20.63.74,30A54.54,54.54,0,0,0,639,294.06C642.11,298.49,646.12,302.23,648.68,307.06Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M633,254c8.7,14.11,14.74,30.83,15.48,47.5,0,.29-.48.37-.52.07-.21-1.5-.44-3-.68-4.46h0c-3.6-3.44-7.29-7.07-9.86-11.38a.08.08,0,0,1,.12-.09A121.17,121.17,0,0,0,647.15,296q-.93-5.52-2.23-10.88c-.24-.27-.46-.54-.69-.81s.1-.43.26-.26l.21.23a127.61,127.61,0,0,0-4.55-14.42c-2.21-2.64-4.68-4.92-6.3-8.1a.07.07,0,0,1,.12-.07,65.2,65.2,0,0,0,4,5.33c.58.68,1.23,1.3,1.83,2a109.89,109.89,0,0,0-7.11-14.83A.19.19,0,0,1,633,254Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M634.8,271.37c2.81,3.78,6,7.39,8.62,11.3.08.11-.08.23-.18.14-3.35-3.15-6.19-7.45-8.63-11.33C634.54,271.36,634.72,271.26,634.8,271.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M643.82,283.54l.12.12c.08.09-.05.22-.13.13l-.12-.12A.09.09,0,0,1,643.82,283.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619.43,281.09c.69,7.26,4.51,15.93,9.17,21.52a22.78,22.78,0,0,0,7.44,5.8c3.22,1.6,6.59,3.43,9.92,4.74a65.48,65.48,0,0,1,3.52,12.48c.11-.36.21-.74.32-1.1-2.14-18.38-14-34.08-29.24-44.16A.73.73,0,0,0,619.43,281.09Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.68,286.52c-.11-.1,0-.29.16-.2a62.21,62.21,0,0,1,19.38,23.88c.11.25-.24.47-.38.22-.71-1.24-1.43-2.44-2.16-3.62h0c-3.47-.66-6.76-3.1-9.34-5.42-.07-.06,0-.16.1-.1a21.35,21.35,0,0,0,4.4,3.08c1.41.72,2.93,1.17,4.41,1.75-1.29-2-2.63-4-4-5.9a40.54,40.54,0,0,1-10.43-5.86c-.1-.08,0-.24.1-.17a105,105,0,0,0,9.69,5.18,85.81,85.81,0,0,0-6.84-8c-1.18-.62-2.38-1.25-3.52-1.92a.09.09,0,0,1,.07-.17,12.71,12.71,0,0,1,2.7,1.32C627.61,289.22,626.2,287.85,624.68,286.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M625,292.86a6.27,6.27,0,0,1,.59.42c.06.05,0,.12-.07.1a4,4,0,0,1-.61-.35C624.8,293,624.9,292.8,625,292.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "673.54 365.43 631.86 365.43 635.22 327.47 635.96 319.1 669.43 319.1 670.17 327.47 673.54 365.43",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "670.17 327.47 635.22 327.47 635.96 319.1 669.43 319.1 670.17 327.47",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 633.97,
    y: 313.25,
    width: 37.46,
    height: 8.28,
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Floor--inject-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "38.31 365.43 122.49 365.18 206.66 365.1 375 364.93 543.34 365.1 627.51 365.18 711.68 365.43 627.51 365.67 543.34 365.76 375 365.93 206.66 365.76 122.49 365.67 38.31 365.43",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-9"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 375,
    cy: 426.69,
    rx: 324.28,
    ry: 25.71,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-9"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.47,
    y: 70.91,
    width: 465.07,
    height: 311.1,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 145.85,
    y: 74.71,
    width: 458.31,
    height: 303.51,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 81.89,
    y: 405.34,
    width: 586.21,
    height: 21.35,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "81.89 405.34 142.47 382.01 607.53 382.01 668.11 405.34 81.89 405.34",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "147.88 397.06 186.96 382.01 563.04 382.01 602.13 397.06 147.88 397.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.75,
    y: 97.77,
    width: 406.51,
    height: 257.39,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 107.67,
    width: 399.64,
    height: 64.95,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 171.4,
    y: 97.77,
    width: 406.85,
    height: 9.9,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M179.27,102.72a2.46,2.46,0,1,1-2.45-2.46A2.45,2.45,0,0,1,179.27,102.72Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.3,102.72a2.46,2.46,0,1,1-2.45-2.46A2.45,2.45,0,0,1,189.3,102.72Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.33,102.72a2.46,2.46,0,1,1-2.45-2.46A2.45,2.45,0,0,1,199.33,102.72Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 571.04,
    y: 107.67,
    width: 7.22,
    height: 247.48,
    style: {
      fill: "#dbdbdb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M574.64,193.47h0a1.86,1.86,0,0,1-1.86-1.86V111a1.86,1.86,0,0,1,1.86-1.86h0a1.87,1.87,0,0,1,1.87,1.86v80.63A1.87,1.87,0,0,1,574.64,193.47Z",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 453.05,
    y: 119.75,
    width: 97.16,
    height: 12.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M550.34,132.85H452.92V119.61h97.42Zm-97.16-.27h96.9v-12.7h-96.9Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 537.11,
    y: 119.61,
    width: 13.24,
    height: 13.24,
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M547.84,129.86l-1.2.91-2.22-2.93-.81-1.07a1.75,1.75,0,0,0,.46-.26,2.07,2.07,0,0,0,.62-.8l.86,1.14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M545.48,123a3.27,3.27,0,1,0-1.06,4.87,2.66,2.66,0,0,0,.45-.29,3.21,3.21,0,0,0,.68-.7A3.27,3.27,0,0,0,545.48,123Zm-1.41,3.54a1.75,1.75,0,0,1-.46.26,2,2,0,0,1-2.28-.62,2,2,0,1,1,3.11-2.38,2,2,0,0,1,.25,1.94A2.07,2.07,0,0,1,544.07,126.51Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 455.76,
    y: 122.29,
    width: 0.7,
    height: 7.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 224.41,
    y: 119.75,
    width: 223.77,
    height: 12.97,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.31,132.85h-224V119.61h224Zm-223.77-.27H448v-12.7H224.54Z",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 227.12,
    y: 122.29,
    width: 0.7,
    height: 7.87,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "199.93 130.67 195.21 126.32 199.92 121.8 200.66 122.56 196.75 126.3 200.65 129.89 199.93 130.67",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "211.33 121.79 216.05 126.14 211.34 130.66 210.61 129.9 214.51 126.15 210.61 122.57 211.33 121.79",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.57,
    y: 186.93,
    width: 103.04,
    height: 79.06,
    transform: "translate(750.18 452.91) rotate(180)",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.83,204.22a9.36,9.36,0,1,0,7.34-7.35A9.36,9.36,0,0,0,333.83,204.22Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 248.95 426.61 248.95 392.09 206.4 357.56 248.95",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "357.56 248.95 426.61 248.95 392.09 206.4 357.56 248.95",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.57 248.99 384.8 248.99 354.19 221.28 323.57 248.99",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "323.57 248.99 384.8 248.99 354.19 221.28 323.57 248.99",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.57,
    y: 248.95,
    width: 103.04,
    height: 17.03,
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 323.57,
    y: 248.95,
    width: 103.04,
    height: 17.03,
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 276.92,
    width: 54.49,
    height: 4.58,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 287.56,
    width: 231.58,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 297.64,
    width: 231.58,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 307.73,
    width: 231.58,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 317.82,
    width: 231.58,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 327.9,
    width: 231.58,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 187.62,
    width: 54.49,
    height: 4.58,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 198.25,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 208.34,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 218.42,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 228.51,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 247.21,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 257.3,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 267.39,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 277.47,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 287.56,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 307.73,
    width: 115.79,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 440.77,
    y: 317.82,
    width: 78.04,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 521.14,
    y: 314.93,
    width: 0.5,
    height: 10.36,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 186.93,
    width: 54.49,
    height: 12.26,
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 207.65,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 217.74,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 227.82,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 237.91,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 251.32,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 193.44,
    y: 261.41,
    width: 115.61,
    height: 4.58,
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Pen--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.61,440.47s-23,1.61-22.86-14.18,23.17-13.67,23.17-13.67Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M585.26,425.15l-.08,6.91L565,442.3v0l0,0-91-1-58.58-.66-6.45-.07h-.68l-4.78,0h-.82l.32-27.86h.92l4.67.05h.68l6.45.07,149.61,1.7v0h0l19.89,10.7Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "589.72 428.65 585.2 430.98 585.19 430.98 585.25 426.28 587.96 427.71 589.72 428.65",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.95,
    y: 423.34,
    width: 32.52,
    height: 6.45,
    transform: "translate(-25.9 826.94) rotate(-89.35)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.08,
    y: 423.42,
    width: 32.52,
    height: 6.45,
    transform: "matrix(0.01, -1, 1, 0.01, -18.91, 834.17)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "415.38 442.94 415.5 432.45 474.16 438.9 473.89 442.76 415.38 442.94",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M261.64,246.25c5.67,6.88,10.17,45.89,3,61.12s-38,18.45-44.65-1.15c-3.49-10.2,5.3-21.6,9.39-48.61C232.41,237.48,253.71,236.65,261.64,246.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.2,313a21.31,21.31,0,0,0,10.18-12.85c1.63-5.86,1.4-12.36,1.11-18.38a112.11,112.11,0,0,0-7.75-35.3s.05-.08.07,0a103.93,103.93,0,0,1,8.26,37.34c.21,6.09.37,12.86-2,18.59a21.5,21.5,0,0,1-9.83,10.73C258.2,313.13,258.14,313,258.2,313Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.42,283.62c1.74-3.7,3.81-7.23,5-11.16s1.7-7.75,2.51-11.64c1.23-6,3.35-12,8.38-15.83,0,0,0,0,0,0-5.13,4.1-6.91,10.52-8.11,16.7-.66,3.38-1.17,6.8-2.12,10.11a50.6,50.6,0,0,1-3.6,8.6c-3.33,6.62-5.93,13.44-4.41,21a19.82,19.82,0,0,0,11.16,14.23c.18.08.05.4-.13.33a19.65,19.65,0,0,1-10.88-12.24C216.11,297,217.47,289.89,220.42,283.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.63,283.93a51.74,51.74,0,0,0,3.46-10.85c.67-3.57,1-7.18,1.62-10.76,1-6.12,2.92-12.41,7.77-16.69.06,0,.15,0,.09.09-4.57,4.51-6.44,10.58-7.44,16.71-1.08,6.61-1.62,13.13-4.13,19.42-2.44,6.11-5.84,12.25-5.5,19s4.83,11.76,10.33,15.18a.12.12,0,0,1-.12.2c-4.86-2.79-9.09-7.22-10.32-12.74C216.88,296.7,220,290.06,222.63,283.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.61,396.35c-2.37.91-71.21,2.17-73.91.63-.29-.18-.21-3.22-1.22-11.08-.05-.37-1.62-1.83-4.08-3.89-9.2-7.71-30.84-24-30.84-24l34.36-29.85,33.29,32.73,8.66,8.5s28.13,15.19,30.92,17.2S466,395.44,463.61,396.35Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M463.61,396.35c-2.36.92-71.22,2.16-73.91.63-.3-.18-.21-3.22-1.22-11.07,8.45,2.25,60.16,3.63,64.11.23,2.64-2.27-7.54-8.39-11.71-10.74,8.22,4.48,18.3,10.05,19.91,11.21C463.55,388.62,466,395.44,463.61,396.35Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.69,359.08l-42.47,22s-44.24-40-48.3-40.35S267.35,380.83,237.38,381c-31,.13-32.61-32.39-32.61-32.39l45.28-10.4c32.63-16.08,66.63-45,88.86-42.28C363.06,298.82,421.69,359.08,421.69,359.08Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.31,353.47c-7.16,3.55-5.15,2.44-12.29,6.06-3.49,1.77-21,10.63-24,12.82a.08.08,0,0,0,.07.14c3.51-1.18,20.88-10.41,24.34-12.25,7.06-3.75,5-2.75,12-6.57A.11.11,0,0,0,411.31,353.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.7,370.94c-8.31-7.32-35.51-31.15-36.61-32a15,15,0,0,0-2.84-2.12,3,3,0,0,0-2.62.21c-1.25.58-2.49,1.23-3.73,1.84l-7.36,3.59c-9.52,4.64-19,9.41-28.57,13.9-9.22,4.32-15.8,8.38-25.43,11.71a145.06,145.06,0,0,1-29.54,7c-1.24.15-2.49.28-3.73.4a.07.07,0,0,0,0,.14,118.56,118.56,0,0,0,29.08-5.41c9.54-2.93,16-6.74,25.07-10.91,9.39-4.32,18.65-8.94,27.9-13.54,4.89-2.43,9.77-4.88,14.67-7.28,1.11-.55,2.69-1.73,4-1.14a6.42,6.42,0,0,1,1.46,1.08l1.63,1.35c2.11,1.75,35.45,30.47,36.54,31.3C371.67,371.12,371.78,371,371.7,370.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.69,348.57s-5.08,29.36,9.6,40.9,122.24,10.14,138.56,4.87,16.84-31.61-1-37.72c-17-5.8-89.16-8.62-90.94-9.33-.45-.18,6.4-4.29,6.37-4.54l-16.43-5Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227,347.83c0-.13-.21-.09-.21,0a14.53,14.53,0,0,1-3.4,9.33c-2.5,2.89-6.18,4.5-9.52,6.19-.32.16-.08.67.25.57a29.63,29.63,0,0,0,5.9-2.55,14.05,14.05,0,0,0,4.43-3.68A12.67,12.67,0,0,0,227,347.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.72,344.19c-.75-.95-1.56-1.86-2.34-2.78-1.84-2.19-3.68-4.39-5.61-6.5-.18-.2-.54.08-.37.3,1.29,1.7,2.67,3.34,4,5,.69.85,1.39,1.69,2.09,2.53a16.63,16.63,0,0,1,1.95,2.48c.5.94-.16,1.74-1.14,1.84a3.33,3.33,0,0,1-2.34-.86,31,31,0,0,1-4-4.26c-.77-.87-1.55-1.74-2.33-2.6s-1.73-1.78-2.56-2.7c-.06-.05-.16,0-.11.09.73,1,1.4,2,2.13,3s1.47,2,2.22,3,1.45,1.84,2.21,2.73a9.31,9.31,0,0,0,2.24,2c1.4.82,3.82,1,4.57-.8A2.56,2.56,0,0,0,259.72,344.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.62,394.43c-5.62.11-11.23.44-16.85.56s-11.15.15-16.73.09q-16.79-.15-33.56-1.3c-11.29-.78-23.46-1.91-34.68-3.46-5.36-.74-10.8-1.36-16.11-2.5a25.45,25.45,0,0,1-12.7-6.49c-7.26-7.05-10.09-17.4-11.25-27.3q-.23-2-.39-4a.07.07,0,1,0-.13,0c.65,10.14,2.23,20.72,8.61,28.88A25.31,25.31,0,0,0,227.22,387c5,2,10.6,2.48,15.9,3.2,11.26,1.53,23.48,2.71,34.81,3.59s22.82,1.43,34.24,1.6,22.87,0,34.28-.56q2.08-.09,4.17-.27A.07.07,0,0,0,350.62,394.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.19,351.27c-3.53-.52-7.06-1-10.62-1.39s-7.19-.7-10.79-1c-7.11-.61-14.25-1.15-21.38-1.48-4.06-.19-8.11-.21-12.16-.16-.13,0-.12.19,0,.2,7.13.64,14.27,1.09,21.42,1.57s14.25,1.1,21.36,1.78c4,.38,8.08.68,12.12,1C315.43,351.82,315.49,351.32,315.19,351.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.11,342.39a55.58,55.58,0,0,0-8.19,4.39,65.14,65.14,0,0,0-7.58,5.3c-.06.06,0,.14.09.11,2.78-1.29,5.45-2.89,8.1-4.43a76.84,76.84,0,0,0,7.75-5C268.45,342.64,268.35,342.3,268.11,342.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.73,289.91c5.45,18.51,15.75,40.48,19.78,43.91,5.1,4.32,37.51,10.86,39.11,10.93,4,.16,10.14-28.67,5.9-29-6.44-.53-29.73-.38-31.21-1.73s-12.08-13.16-23-26.51C240.76,278.25,234.35,278.42,237.73,289.91Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.37,343.42a87.06,87.06,0,0,0,11.54,4.1c3.13.7,12.19,2.49,13.31-.88.76-2.3-4.44-4-8.09-5.24-1.93-.67-4.36-2.49-3.88-3.73.84-2.17,5.8-.35,9.09,1.31,6.36,3.19,14.94,9.12,18.5,5.78,1.35-1.27-.43-3.31-3-5.27,4.06,2.21,8.36,4,9.91,2.63a2.07,2.07,0,0,0,.28-2.83,2.74,2.74,0,0,0,3-.65c1.19-1.41.46-3.34-1.06-5.27a1.49,1.49,0,0,0,1.11-.83c2.44-4.26-11.75-15.23-16.47-16.05a117.9,117.9,0,0,0-28.32-.94C294.18,320.18,293.36,343.41,293.37,343.42Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.76,329.57a23.34,23.34,0,0,1,9.36,3c3.62,2.09,6.09,4.63,9.17,7.16a.08.08,0,0,1-.1.13c-1.47-1.2-7.52-5.69-9.08-6.69a22.11,22.11,0,0,0-9.36-3.5A0,0,0,0,1,312.76,329.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315,323.6a55.16,55.16,0,0,1,10.87,3c3.77,1.64,6.82,4.51,9.81,7.26,1.8,1.66,3.57,3.35,5.29,5.08.07.07,0,.2-.1.13q-4.57-4.28-9.38-8.27a29.3,29.3,0,0,0-10.08-5.52c-2.11-.66-4.26-1.16-6.42-1.66C314.91,323.65,314.92,323.59,315,323.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.5,318.28c3.55.5,6.64.93,9.85,2.62a49.89,49.89,0,0,1,10,7.58c1.63,1.54,3.21,3.14,4.77,4.76.06.07-.05.18-.11.12a116.18,116.18,0,0,0-11.33-9.93,22.85,22.85,0,0,0-6.21-3.52,41,41,0,0,0-6.93-1.61S318.49,318.27,318.5,318.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297,314.52l-7.92,31.67s-27-6-32.19-10.9-15.77-31.42-19.2-44.36,3.21-13,9.8-5.13,23,27,23.84,27.37S297,314.52,297,314.52Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.72,332.54c1-3.73,2-7.46,2.79-11.23.47-2.15.95-4.29,1.4-6.44,0-.08-.12-.12-.14,0-1.12,3.71-2.23,7.44-3.18,11.2s-1.92,7.48-2.81,11.23c-.51,2.14-.95,4.28-1.33,6.45,0,0,.06.06.08,0C283.77,340.05,284.75,336.3,285.72,332.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.82,314.3a13.85,13.85,0,0,1-.13,2.13,12.27,12.27,0,0,1-.51,2.07,12.8,12.8,0,0,1-2.05,3.73,9.32,9.32,0,0,1-3.29,2.69,13.27,13.27,0,0,1-4.08,1.18,22.88,22.88,0,0,1-3.6.2h-.65c-1.41,0-2.82-.15-4.23-.27a82.48,82.48,0,0,0-8.45-.56,15.74,15.74,0,0,0-4.16.56,7.69,7.69,0,0,0-2.78,1.44l-.06-.12a7.8,7.8,0,0,1,2.8-1.45,15.71,15.71,0,0,1,4.2-.58,79.56,79.56,0,0,1,8.46.54c1.41.12,2.82.23,4.23.26h.87a23.32,23.32,0,0,0,3.34-.21,13,13,0,0,0,4-1.17A8.94,8.94,0,0,0,283,322.1a12.87,12.87,0,0,0,2-3.67,12,12,0,0,0,.63-4.13,2.26,2.26,0,0,0,0-.26h.22A2.09,2.09,0,0,1,285.82,314.3Zm-8.43-.61v-.05h-.2a.17.17,0,0,1,0,.07,15.9,15.9,0,0,1-.27,4.19,16,16,0,0,1-3.88,7.37,12.33,12.33,0,0,1-.91.86,1.92,1.92,0,0,1-.22.18,13.2,13.2,0,0,1-2.22,1.48,21.1,21.1,0,0,1-3.93,1.54,57.8,57.8,0,0,0-8.1,2.49,14.07,14.07,0,0,0-2.44,1.41.46.46,0,0,1,.07.1,13.62,13.62,0,0,1,2.43-1.39,57.57,57.57,0,0,1,8.08-2.47,21.65,21.65,0,0,0,4-1.54,12.41,12.41,0,0,0,2.39-1.62,1.3,1.3,0,0,0,.23-.18q.41-.36.78-.75a15.1,15.1,0,0,0,2.46-3.46,14.89,14.89,0,0,0,1.47-4A15.49,15.49,0,0,0,277.39,313.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.9,343l-.79,3.15s-27-6-32.19-10.9-15.77-31.42-19.2-44.36c-2.51-9.46.37-12.05,4.67-9.67C254.36,296.52,276.93,325.47,289.9,343Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.33,351.67c2,.76,60.81-13.08,60.81-13.08l-5.83-20.47s3.71-6.3,2.45-12.61c-1.67-8.42-16.38-22.87-17.54-23.73-4.7-3.47-9-4.14-13.09-2.21C211.92,287.63,202.33,351.67,202.33,351.67Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.57,300.18l.09.17-.43,0H257a10.26,10.26,0,0,0-1.24,0,14.89,14.89,0,0,0-4.12.85,14.46,14.46,0,0,0-3.74,1.89,15.81,15.81,0,0,0-3.07,2.88,28.91,28.91,0,0,0-2.4,3.47c-.73,1.2-1.42,2.44-2.16,3.64a23.47,23.47,0,0,1-2.51,3.44,14.25,14.25,0,0,1-1.55,1.46,11,11,0,0,1-1.79,1.17,12.89,12.89,0,0,1-4,1.33,9.36,9.36,0,0,1-4.24-.28,13.15,13.15,0,0,1-3.79-1.92,24.28,24.28,0,0,1-2.75-2.3l-.18-.18-.3-.28c-1-1-2-2-2.91-3.09-1.27-1.41-2.5-2.85-3.81-4.22a1.21,1.21,0,0,0,.05-.18c1.34,1.39,2.6,2.85,3.89,4.28.94,1.05,1.9,2.09,2.9,3.08l.45.42.18.18a23.82,23.82,0,0,0,2.59,2.13,12.92,12.92,0,0,0,3.74,1.89,9.07,9.07,0,0,0,4.14.26,12.94,12.94,0,0,0,4-1.31,12.43,12.43,0,0,0,3.28-2.59,22.48,22.48,0,0,0,2.49-3.4c.74-1.2,1.43-2.43,2.17-3.64a27.81,27.81,0,0,1,2.43-3.48,15.5,15.5,0,0,1,3.1-2.9,15.87,15.87,0,0,1,8-2.76c.36,0,.72,0,1.08,0h.28Zm.55,1-.59-.6-.3-.29-.17-.17a23.37,23.37,0,0,0-2.76-2.3,13,13,0,0,0-3.79-1.92,9.22,9.22,0,0,0-4.24-.28,13.13,13.13,0,0,0-4,1.32,12.52,12.52,0,0,0-1.79,1.17,14.34,14.34,0,0,0-1.55,1.47,23.38,23.38,0,0,0-2.51,3.43c-.74,1.21-1.43,2.44-2.16,3.65a29.36,29.36,0,0,1-2.4,3.47,16.31,16.31,0,0,1-3.06,2.87,15,15,0,0,1-3.75,1.9,14.88,14.88,0,0,1-4.12.84,8.69,8.69,0,0,1-1.25,0,1.22,1.22,0,0,1-.27,0,13.32,13.32,0,0,1-2.65-.43,21.26,21.26,0,0,1-3.91-1.56c-.63-.32-1.26-.65-1.88-1a.74.74,0,0,0,0,.14c.61.33,1.23.67,1.85,1a20.66,20.66,0,0,0,3.94,1.58,14,14,0,0,0,2.87.46h.27c.36,0,.72,0,1.08,0a15.62,15.62,0,0,0,4.17-.85,15,15,0,0,0,3.79-1.91,16.45,16.45,0,0,0,3.11-2.9,28.93,28.93,0,0,0,2.42-3.49c.74-1.21,1.43-2.44,2.17-3.64a24.52,24.52,0,0,1,2.49-3.4,12.48,12.48,0,0,1,3.29-2.58,12.9,12.9,0,0,1,4-1.32,9.21,9.21,0,0,1,4.14.27,13,13,0,0,1,3.74,1.88,23.91,23.91,0,0,1,2.59,2.14l.17.17.46.43c.33.32.65.65,1,1-.07-.17-.16-.34-.24-.5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.8,289.42c1.41,1.82,2.93,3.55,4.38,5.33-.65-1.31-1.3-2.61-2-3.89,0,0,0-.06,0,0a28.29,28.29,0,0,1,2.71,4.83,39.35,39.35,0,0,1,3,4.24,18,18,0,0,1,2.35,5.74,15.52,15.52,0,0,1-.13,6.22,40.08,40.08,0,0,1-2.31,6.83c-.12.3-.54.09-.44-.2,1.29-3.88,2.73-8,2.06-12.11s-3-7.66-5.32-11a57.7,57.7,0,0,0-4.43-5.86C249.61,289.44,249.74,289.34,249.8,289.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.47,283.28c-11.73,9-42.66,45.53-36.2,54.19s50.78,5.78,63.71,2c3.85-1.11-6-25.58-10.13-26.79-3.41-1-22.6,4.2-22.94,3.08s3.85-9.34,10.71-24.13C236.52,274.63,228.66,279.3,223.47,283.28Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.76,308.48c8.86.23,11.1,1.65,18.68-2.13,5-2.48,8.7-.37,5.32,4.32-5.53,7.68-17,9.79-21.23,9.37Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,313s10.63-3.8,20.1-4.49c6.55-.48,20.91.07,32.08,16.18,2.65,3.82,3.71,11.14-2.88,6.47-4.68-3.32-6.65-6.83-9.72-8.27,0,0,.24,9.48-3.69,12a85.63,85.63,0,0,1-10.74,5.81,18.28,18.28,0,0,1-1.27-1.91s-3.89,2-10.32.29Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.78,309.07c2.76,2.07,8.51,6.55,12,11.85,3.81,5.9,9.57,18.27,5.2,21-3.21,2-5.83-2.5-5.83-2.5s1.3,5.62-2,6.82c-3,1.1-4.82-2.53-4.82-2.53s.21,3.54-2.9,4c-3.73.6-3.54-6.93-7.84-9.59C254.57,337.61,261.78,309.07,261.78,309.07Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M266.83,323.92a27.94,27.94,0,0,1,6.34,15.42c0,.14-.1.22-.13.09A68.82,68.82,0,0,0,266.77,324,0,0,0,0,1,266.83,323.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,327.94c1.74,2.25,5.32,9.33,5.4,15.77,0,.14-.11.22-.13.09A74.09,74.09,0,0,0,260.94,328S261,327.91,261,327.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275,322.86c2.68,1.29,4.29,3,6.4,5a37.42,37.42,0,0,0,3.26,2.91c1,.81,2.58,2,4,1.26a2.34,2.34,0,0,0,.9-2.22,11.25,11.25,0,0,0-1-3.47s.05-.08.07,0a15.71,15.71,0,0,1,1.23,3.15,3.8,3.8,0,0,1-.11,2.24c-.67,1.49-2.54,1.39-3.77.75a12.25,12.25,0,0,1-2.05-1.45c-.62-.5-1.21-1-1.79-1.59-1.2-1.13-2.32-2.32-3.5-3.47a40.61,40.61,0,0,0-3.65-3C274.84,322.91,274.89,322.83,275,322.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.22,333.77a92,92,0,0,0-4.34-10.86s0-.08.07,0a46.69,46.69,0,0,1,5,10.49,15.62,15.62,0,0,1,.77,6.24c-.49,2.95-2.54,3.19-3.28,3.21A3.88,3.88,0,0,1,275,342a7.75,7.75,0,0,1-1.92-2.51c0-.05,0-.09.07-.05.83,1.33,2.34,2.76,4,2.82a2.72,2.72,0,0,0,2-.69,3.54,3.54,0,0,0,.87-2.29A16.49,16.49,0,0,0,279.22,333.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.36,313l8.9,31s-55.41,3.16-58.48-6.9,23.7-43,34.81-52.08c12.86-10.49,13.55-6.08,9.37,4.41-4.39,11-11.94,26.67-11.94,26.67Z",
    style: {
      fill: "#37474F"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.56,310.74l-.09.2a8.18,8.18,0,0,1-1,0,13,13,0,0,1-4.12-1.05,24.66,24.66,0,0,1-3.19-1.65l-.22-.13-.34-.21c-1.2-.75-2.36-1.56-3.51-2.39-1.34-1-2.67-1.95-4-2.89l.1-.12c1.36.93,2.69,1.92,4,2.87,1.15.82,2.31,1.63,3.5,2.37l.53.32.22.13a22.64,22.64,0,0,0,3,1.53,13.1,13.1,0,0,0,4.06,1A9.55,9.55,0,0,0,220.56,310.74Zm8.16-24.42a13.11,13.11,0,0,0-1.2,1.77,22.37,22.37,0,0,0-1.7,3.89c-.47,1.34-.87,2.7-1.32,4a28.38,28.38,0,0,1-1.6,3.91,16.1,16.1,0,0,1-2.36,3.47,14.84,14.84,0,0,1-3.25,2.66,15.14,15.14,0,0,1-3.83,1.72,9,9,0,0,1-1.23.27,1.37,1.37,0,0,1-.28,0,12.47,12.47,0,0,1-2.66.15,20.86,20.86,0,0,1-4.16-.67c-1.37-.35-2.73-.77-4.09-1.13l-.09.11c1.38.38,2.75.81,4.14,1.16a20.47,20.47,0,0,0,4.19.68,13.29,13.29,0,0,0,2.89-.17l.28-.05a9.92,9.92,0,0,0,1.05-.24,16,16,0,0,0,7.17-4.42,15.76,15.76,0,0,0,2.4-3.5,29.81,29.81,0,0,0,1.62-3.93c.45-1.34.86-2.7,1.33-4a22,22,0,0,1,1.69-3.85,12.35,12.35,0,0,1,2.64-3.24,11.06,11.06,0,0,1,1.49-1.08c0-.11,0-.2.07-.3a11.91,11.91,0,0,0-1.7,1.21A12.66,12.66,0,0,0,228.72,286.32Zm5.05,27-.07,0a14.4,14.4,0,0,1,.12,1.86c0,.39,0,.77,0,1.16,0,0,0,.09,0,.14a16.51,16.51,0,0,1-.49,2.88,15.23,15.23,0,0,1-1.59,3.9,13.92,13.92,0,0,1-2.66,3.26,60.06,60.06,0,0,1-6.92,4.86,20.7,20.7,0,0,0-3.28,2.69,13.63,13.63,0,0,0-1.79,2.28l-.15.25c-.18.31-.35.62-.5.94a16.27,16.27,0,0,0-1.51,6.75h.18a15.84,15.84,0,0,1,.23-2.66,14.88,14.88,0,0,1,1.24-4,11.56,11.56,0,0,1,.6-1.09,1.11,1.11,0,0,1,.16-.24,12.82,12.82,0,0,1,1.65-2.1,20.41,20.41,0,0,1,3.25-2.68c2.32-1.6,4.84-2.95,6.93-4.89a14.12,14.12,0,0,0,2.67-3.29,15.08,15.08,0,0,0,1.59-3.93,16.41,16.41,0,0,0,.46-2.79c0-.05,0-.1,0-.14,0-.43,0-.85,0-1.28A17,17,0,0,0,233.77,313.3Zm3.46,10.6a10.86,10.86,0,0,0-1.31-4c-.62-1.18-1.35-2.29-2.06-3.41l-.08-.12a26.94,26.94,0,0,1-1.58-2.76h-.06a27.41,27.41,0,0,0,1.63,2.89l.07.12c.69,1.09,1.4,2.18,2,3.32a10.92,10.92,0,0,1,1.28,4,8.51,8.51,0,0,1-.65,4.11,7.43,7.43,0,0,1-2.69,3.16A15.8,15.8,0,0,1,230,333a84,84,0,0,1-8.19,2.09c-1.38.32-2.76.65-4.11,1.06l-.39.12-.25.07a25.09,25.09,0,0,0-3.34,1.3,13.18,13.18,0,0,0-3.51,2.4,9.27,9.27,0,0,0-2.3,3.57l-.09.27.22,0a1.87,1.87,0,0,1,.07-.22,9.14,9.14,0,0,1,2.24-3.5,13,13,0,0,1,3.45-2.36,23.65,23.65,0,0,1,3.11-1.23,1.13,1.13,0,0,1,.24-.08l.6-.19c1.35-.4,2.72-.74,4.09-1.06a83.09,83.09,0,0,0,8.21-2.12,15.9,15.9,0,0,0,3.82-1.86,7.56,7.56,0,0,0,2.73-3.22A8.63,8.63,0,0,0,237.23,323.9Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.51,321.07a64.17,64.17,0,0,1,8.55-3.29,62,62,0,0,1,8.84-1.95c1.7-.27,3.41-.45,5.12-.64.06,0,.06.07,0,.08a79.66,79.66,0,0,0-8.91,1.87q-4.38,1.14-8.7,2.44c-1.64.49-3.25,1.06-4.86,1.61A.07.07,0,0,1,200.51,321.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.23,312.91c-.28,0-15.69,2.43-16.21,2.58.1-.21,4-7.55,4.59-8.62.06-.11.11-.22.17-.32.35-.47.7-.93,1-1.4l1.27-1.85s0,0,0,0l-1.34,1.78q-.32.42-.6.84c.39-.76.77-1.52,1.15-2.29.61-1.23,1.17-2.47,1.74-3.71,0,0-.05-.07-.07,0-1.15,2.14-2.36,4.24-3.52,6.37s-5.54,10-5.52,10,17-3,17.37-3.09A.11.11,0,0,0,235.23,312.91Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M233.11,331.82c-1-3.46-1.92-6.92-3-10.34-.62-2-1.24-3.89-1.88-5.83,0-.07-.15,0-.14,0,.84,3.51,1.69,7,2.69,10.49s2,6.91,3,10.35q.88,2.94,2,5.8s.08,0,.07,0C235.06,338.77,234.09,335.3,233.11,331.82Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.88,344.57c-.39-1-.86-2.36-1.29-3.31-.11-.26-.29-.24-.21,0,.27.87.46,1.83.73,2.72-.78,0-1.55,0-2.33.07l-2.69.11c-1.75.07-3.51.12-5.26.16q-5.34.09-10.67,0a208.42,208.42,0,0,1-21.34-1.5c-2-.26-4-.55-5.92-.9a58.58,58.58,0,0,1-5.76-1.24s-.08.07,0,.09a32,32,0,0,0,4.95,1.49c1.76.38,3.54.72,5.33,1,3.56.55,7.14.91,10.73,1.17q10.68.76,21.4.64,3,0,6-.13l3-.12A19.28,19.28,0,0,0,244.88,344.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234,280.64c0,1.08,3.39,8.83,8.12,9.67,1.54.27,3.39-8.07,3.39-8.07l.28-.59,3.87-8.18-9.92-10S234,280.19,234,280.64Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.63,273.46l-3.87,8.19a18.21,18.21,0,0,1-8-12.45c1-2.9,1.81-5.31,1.92-5.66a.1.1,0,0,0,0-.05l1.28,1.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M265.56,264.28c-2.22,15.73-11.9,16.18-15.29,15.7-3.08-.44-13.51-2.33-12.92-18.21s8.6-19.82,15.7-19.19S267.79,248.54,265.56,264.28Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.64,262.57c-.36-.12-.66-.29-1-.44a1.81,1.81,0,0,1-.94-.65.57.57,0,0,1,.15-.68,1.41,1.41,0,0,1,1.42,0,2.06,2.06,0,0,1,1.11,1A.6.6,0,0,1,263.64,262.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.05,260.47c.37,0,.72,0,1.1,0a1.8,1.8,0,0,0,1.12-.21.58.58,0,0,0,.14-.68,1.4,1.4,0,0,0-1.28-.61,2.08,2.08,0,0,0-1.42.45A.61.61,0,0,0,253.05,260.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.11,263.22s-.09,0-.1.08c-.16,1.07-.54,2.27-1.56,2.44,0,0,0,.06,0,.06C254.65,265.86,255.13,264.26,255.11,263.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.37,261.93c-1.68-.45-2.46,3-.9,3.38S255.79,262.31,254.37,261.93Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.66,262c-.34.12-.71.4-1.07.35s-.66-.48-.85-.89c0,0-.06,0-.07,0a1.27,1.27,0,0,0,.62,1.63c.61.24,1.2-.23,1.52-.85C253.87,262.11,253.8,261.91,253.66,262Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261,264.3s.07.07.06.11c-.28,1-.43,2.29.44,2.87,0,0,0,.07,0,.05C260.31,266.89,260.52,265.24,261,264.3Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.16,263.42c1.73.28,1,3.71-.55,3.45S260.72,263.19,262.16,263.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.83,263.79c.24.24.44.62.76.7s.72-.21,1-.52c0,0,.05,0,.05,0-.11.65-.47,1.29-1.12,1.3s-.91-.65-.94-1.33C262.61,263.86,262.74,263.7,262.83,263.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.75,272.43c.18.32.33.72.7.86a2.86,2.86,0,0,0,1.2,0s.06,0,0,.06a1.44,1.44,0,0,1-1.48.2,1.16,1.16,0,0,1-.57-1.15C252.63,272.39,252.72,272.39,252.75,272.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.16,269.49s-.13,1.63-.29,2.38c0,.07-.2.06-.46,0h0a3.62,3.62,0,0,1-3.15-2.07c0-.08.08-.14.13-.08a5.43,5.43,0,0,0,3,1.63c.1-.19.13-2.79.25-2.77a6.36,6.36,0,0,1,1.6.75c.36-3.38.18-6.79.59-10.15a.1.1,0,0,1,.2,0,54.94,54.94,0,0,1-.16,11C259.84,270.58,258.43,269.69,258.16,269.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,271.53a4.06,4.06,0,0,1-1.84.93,1.79,1.79,0,0,1-1.11-.14c-.76-.36-.64-1.09-.37-1.69a4.41,4.41,0,0,1,.54-.88A5.28,5.28,0,0,0,257,271.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.2,272.46a1.79,1.79,0,0,1-1.11-.14c-.76-.36-.64-1.09-.37-1.69A1.91,1.91,0,0,1,255.2,272.46Z",
    style: {
      fill: "#ff9bbc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.15,262.61a6.57,6.57,0,0,0,5-4.08,17.15,17.15,0,0,0,8.3-3.4c-.2.28-1.61,2.34-2.36,3.36,10.23,1.07,15.43-5.46,15.43-5.46a17.47,17.47,0,0,1,2.4,7.4s1.84-5.92,0-10.81a10,10,0,0,0-7.67-6.58,14.31,14.31,0,0,0-14.61.14C235.32,248.17,237.15,262.61,237.15,262.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256,259.08a18.91,18.91,0,0,1-5.51.35s0,0,0,0a15.75,15.75,0,0,0,8.39-2.19,15,15,0,0,0,3-2.3,10.38,10.38,0,0,0,2.39-3.31.07.07,0,1,1,.14.05,12.19,12.19,0,0,1-1.9,3.6,11.19,11.19,0,0,1-3.11,2.57,13,13,0,0,1-3.36,1.26",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.68,263.33s-2.27-5.61-4.74-4.91-1.55,8.29.81,9.84a2.69,2.69,0,0,0,3.83-.6Z",
    style: {
      fill: "#d3766a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.26,260.59s-.06,0,0,.06c1.64,1.15,2.2,3,2.46,4.93a1.48,1.48,0,0,0-2.07-.89c-.05,0,0,.11,0,.11a1.64,1.64,0,0,1,1.64,1,7.74,7.74,0,0,1,.52,1.63c.05.18.36.16.34,0v-.05C238.72,265,237.68,261.39,235.26,260.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.4,
    y: 351.21,
    width: 65.43,
    height: 2.93,
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "321.83 351.21 321.83 354.14 277.36 354.14 279.6 351.21 321.83 351.21",
    style: {
      fill: "#a6a6a6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "282.42 354.14 346.19 354.14 351.5 310.83 287.73 310.83 282.42 354.14",
    style: {
      fill: "#c7c7c7"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M313.08,332.49a3.8,3.8,0,0,0,3.81,3.88,4,4,0,0,0,3.95-3.88,3.79,3.79,0,0,0-3.81-3.88A4,4,0,0,0,313.08,332.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M325.26,233.3a23.85,23.85,0,0,1-39.86,15.09l-11.94,1.76,6-10.32a23.86,23.86,0,1,1,45.82-6.53Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M318.3,213.42a24.36,24.36,0,0,0-39.66,26.36l-6.2,10.79a.29.29,0,0,0,0,.27.24.24,0,0,0,.25.1L285.21,249a24.24,24.24,0,0,0,11.72,5.7,21.28,21.28,0,0,0,3.32.35c.34,0,.68,0,1,0,.6,0,1.19,0,1.77-.07l.59,0a23.36,23.36,0,0,0,6.48-1.54,23.68,23.68,0,0,0,5.81-3.23,17.28,17.28,0,0,0,1.85-1.53l.71-.65.66-.71a15.36,15.36,0,0,0,1.51-1.79,24.15,24.15,0,0,0,4.87-12.22h0A24.38,24.38,0,0,0,318.3,213.42ZM325,233.28a23.51,23.51,0,0,1-4.84,11.92,16.27,16.27,0,0,1-1.48,1.73c-.23.23-.45.47-.65.69l-.7.62a15.27,15.27,0,0,1-1.81,1.47,21.93,21.93,0,0,1-5.69,3.07,23.73,23.73,0,0,1-6.29,1.39l-.58,0a18.34,18.34,0,0,1-2.67,0,19.7,19.7,0,0,1-3.19-.39A23.11,23.11,0,0,1,285.8,248l-.11-.11a.28.28,0,0,0-.17-.07h0l-10.74,1.51,5.43-9.3a.24.24,0,0,0,0-.22l-.08-.21a23.63,23.63,0,0,1-1.66-10.28,23.08,23.08,0,0,1,3-10,24.35,24.35,0,0,1,7.07-7.71,23.31,23.31,0,0,1,9.74-3.85,23.54,23.54,0,0,1,10.5.79A23.43,23.43,0,0,1,325,233.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M292.31,231.77a2.6,2.6,0,1,1-2.6-2.59A2.6,2.6,0,0,1,292.31,231.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.82,
    cy: 231.77,
    r: 2.59,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 313.93,
    cy: 231.77,
    r: 2.59,
    style: {
      fill: "#263238"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlog3);
export default __webpack_public_path__ + "static/media/blog3.54926b20c31cb499eec1040f6b938d2a.svg";
export { ForwardRef as ReactComponent };